// extracted by mini-css-extract-plugin
export var chip = "_qh-0";
export var icon = "_qh-1";
export var remove = "_qh-2";
export var removeIcon = "_qh-3";